module.exports = __webpack_public_path__ + "static/media/faqBalance-en-tl.ce054137.vtt";